import { VehicleTypesType } from '@/common/types/Files.type';
import { ImageFlowStoreType } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/imageFlowStore.type';

export type ImagesPostData = {
  initialImages: {
    title: string;
    image: Blob;
  }[];
  damagedImages: {
    part: string;
    image: Blob;
  }[];
  vehicleType: VehicleTypesType;
};

export const createImagesFlowPostData = () => {
  const createPostData = ({
    images,
    video,
  }: {
    images: ImageFlowStoreType['images'];
    video: ImageFlowStoreType['video'];
  }) => {
    const toImage = (blob?: Blob, title?: string) => ({
      title: title || 'Untitled',
      image: blob ?? new Blob(),
    });
    const initialImages = [
      ...images.vehicleImages.map((image) =>
        toImage(image?.blob, image.en_name),
      ),

      ...images.extraImages.map((image, index) =>
        toImage(image.blob, `arb_image_${index + 1}`),
      ),

      ...[toImage(video?.blob, 'background_video')],
    ];

    const damagedImages = images.damagedImages.map((image) => ({
      part: String(image.id ?? ''),
      image: image.blob ?? new Blob(),
    }));
    return { initialImages, damagedImages };
  };
  const createPostFormData = ({
    initialImages,
    damagedImages,
    vehicleType,
  }: ImagesPostData) => {
    const urlToFile = (
      blob: Blob,
      title: string,
      type: 'video' | 'image',
    ): File => {
      return new File(
        [blob as Blob],
        type === 'video' ? `${title}.mp4` : `${title}.jpeg`,
        {
          type: type === 'video' ? 'video/mp4' : 'image/jpeg',
        },
      );
    };

    const formData = new FormData();
    initialImages.forEach((item, index) => {
      const title =
        vehicleType === 'motorcycle'
          ? 'motor_background_video'
          : 'background_video';

      formData.append(
        `initial_images[${index}][title]`,
        item.title === 'background_video' ? title : item.title,
      );
      const file = urlToFile(
        item.image,
        item.title,
        item.title === 'background_video' ? 'video' : 'image',
      );
      formData.append(`initial_images[${index}][image]`, file);
    });
    damagedImages.forEach((item, index) => {
      formData.append(`damaged_images[${index}][part]`, item.part);
      const file = urlToFile(item.image, `part-${item.part}`, 'image');
      formData.append(`damaged_images[${index}][image]`, file);
    });
    return formData;
  };

  return { createPostData, createPostFormData };
};
